module.exports = __webpack_public_path__ + "fonts/fa-solid-900.b1e2167.woff";